export const EmployeeRewardWelfareEN = {
    "EmployeeRewardWelfareTitle": {
        "date" : "Date of enjoyment",
        "benefitName" : "Benefit name",
        "money" : "money",
        "moneyNumber" : "1,000,000",
        "form" : "Form",
        "paid" : "Paid",
        "paidOk" : "This benefit has been paid to the employee",
        "calculateSalary" : "Calculate salary",
        "payroll" : "This benefit will be added directly to the payroll"
    },
    "NotificationEmployeeRewardWelfare": {
        "edit": "Edit data successfully...",
        "add": "Add data successfully...",
        "delete": "Delete data successfully...",
    }
}